export default "__VITE_ASSET__Dy9glhRF__"